"use strict";

import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
export const MOUNT_CRITICAL_FLAGS = ['datadog-enabled', 'datadog-minimal', 'datadog-high-fidelity'];
export const DEFAULT_FLAG_VALUES = {
  'datadog-enabled': false,
  'datadog-minimal': false,
  'datadog-high-fidelity': false
};
export const isMountCriticalFlag = flag => MOUNT_CRITICAL_FLAGS.includes(flag);